module.exports = __webpack_public_path__ + "static/media/kropla.3060b8b3.svg";